export default "__VITE_ASSET__CEy3xlGI__"